import httpClient from "@/libs/http-client";

function post(url, data = {}) {
  return httpClient.post(url, data).then(response => response.data);
}

export function createPortfolioToken(data) {
  return post("/api/super/portfolio/createToken", data);
}

export function getPortfolioTokenList() {
  return post("/api/super/portfolio/tokenList");
}

export function expirePortfolioToken(portfolioToken) {
  return post("/api/super/portfolio/expireToken", { portfolioToken });
}

export function expireAllPortfolioTokens() {
  return post("/api/super/portfolio/expireAllToken");
}
